<div class="container">
  <mat-card class="card" *ngIf="!start">
    <mat-card-header>
      <mat-card-title>{{ 'Instructions.Title' | translate }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <ul>
        <li>{{ 'Instructions.GameDesignedFor' | translate }}</li>
        <li>{{ 'Instructions.Requirements' | translate }}</li>
        <li>{{ 'Instructions.GameDuration' | translate }}</li>
        <li>{{ 'Instructions.EachPlayer' | translate }}</li>
        <li>{{ 'Instructions.WinCondition' | translate }}</li>
        <li>{{ 'Instructions.TaskFailed' | translate }} <b>{{ 'Timer.EveryBodyDrinks' | translate }}</b></li>
      </ul>
      <h2>{{ 'Instructions.DontForgetAboutYourHealth' | translate }}</h2>
    </mat-card-content>
    <mat-form-field>
      <mat-label>{{ 'Instructions.SelectLanguage' | translate }}</mat-label>
      <mat-select [(value)]="selected" (selectionChange)="selectLanguage($event)">
        <mat-option value="en">English</mat-option>
        <mat-option value="ru">Русский</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-card-actions>
      <button class="next-button" mat-raised-button color="primary" (click)="next()">{{ 'Next' | translate }}</button>
    </mat-card-actions>
  </mat-card>
  <mat-card class="card" *ngIf="start">
    <mat-card-content>
      <img src="/assets/Drinking-Party-Vs-NET.png">
      <h1>Drinking Party vs NET</h1>
    </mat-card-content>
    <mat-card-actions>
      <button class="next-button" mat-raised-button color="primary" (click)="startGame()">{{ 'Start' | translate }}</button>
    </mat-card-actions>
    <a href="http://trainonhand.com/" target="_blank" rel="noopener">{{ 'OurWebsite' | translate }}</a>
  </mat-card>
</div>
